<template>
  <input type="text" v-model="formattedCurrencyValue" @blur="focusOut" @focus="focusIn" />
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      formattedCurrencyValue: '0'
    }
  },
  computed: {
    currencyValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    focusOut: function () {
      // Recalculate the currencyValue after ignoring "$" and "," in user input
      this.currencyValue = parseFloat(this.formattedCurrencyValue.replace(/[^\d\.]/g, ''))
      // Ensure that it is not NaN. If so, initialize it to zero.
      // This happens if user provides a blank input or non-numeric input like "abc"
      if (isNaN(this.currencyValue)) {
        this.currencyValue = 0
      }
      // Format display value based on calculated currencyValue
      this.formattedCurrencyValue =
        '$ ' + this.currencyValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    },
    focusIn: function () {
      // Unformat display value before user starts modifying it
      this.formattedCurrencyValue = this.currencyValue.toString()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/CurrencyInput.vue